// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"1edeeeb9","661":"5a99d366"}[chunkId] + ".chunk.js";
};